import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'

export const PageViewedEventSchema: EventSchema = {
  eventName: EN.PAGE_VIEWED,
  params: {
    // common properties
    SESSION_ID_GA: EPK.SESSION_ID_GA,
    GCLID: EPK.GCLID,
    FBCLID: EPK.FBCLID,
    REFERRER: EPK.REFERRER,
    REFERRING_DOMAIN: EPK.REFERRING_DOMAIN,
    SCREEN_NAME: EPK.SCREEN_NAME,
    SCREEN_SECTION: EPK.SCREEN_SECTION,
    PREVIOUS_SCREEN_NAME: EPK.PREVIOUS_SCREEN_NAME,
    PREVIOUS_SCREEN_SECTION: EPK.PREVIOUS_SCREEN_SECTION,
    ENVIRONMENT: EPK.ENVIRONMENT,
    BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
    EVENT_CATEGORY: EPK.EVENT_CATEGORY,
    MEMBERSHIP_STATUS: EPK.MEMBERSHIP_STATUS,
    CURRENT_PLAN_TYPE: EPK.CURRENT_PLAN_TYPE
  },
}
